<template>
  <el-dialog title="Retirar Placa do Imóvel" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      
      <el-form-item label="Placa Instalada">
        <el-input :value="placa.tipo" readonly disabled />
      </el-form-item>

      <el-form-item label="Situação da Retirada" style="width: 100%">
        <el-select v-model="placa.status" style="width: 100%">
          <el-option
            v-for="item in ocorrenciaRetiradaPlaca"
            :key="item.data"
            :label="item.label"
            :value="item.data">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Data de Retirada">
        <el-date-picker
          v-model="placa.dataRemocao"
          v-mask="'##/##/####'"
          type="date"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
          style="width: 100%"
        />
      </el-form-item>

    </el-form>
    <span slot="footer">
      <el-button @click="retirarPlaca()" type="primary" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { OCORRENCIA_RETIRADA_PLACA } from '../../../util/constantes.js';

export default {
  props: {
    placa: Object,
    visibility: Boolean
  },
  computed: {
    ocorrenciaRetiradaPlaca() { return OCORRENCIA_RETIRADA_PLACA }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisImoveisStore', [
      'removerPlacaImovel'
    ]),
    retirarPlaca() {
      let payload = this.placa;

      this.showLoading()
      this.removerPlacaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>
